@import '../../assets/styles/components.css';

@layer components {
  :host {
    a,
    button {
      @apply overflow-hidden;
      @apply flex items-center justify-center;
      @apply duration-150 ease-out transition;
      @apply h-8 w-8;
      @apply focus:outline-none focus:ring focus:ring-primary-200 rounded;
      @apply text-brand-500;
      @apply hover:text-brand-600;
      @apply active:text-brand-700;
    }

    .inline {
      @apply h-auto w-auto;
    }
    [class*='transparent'] {
      @apply bg-transparent;
    }
    [class*='outline'] {
      @apply outline-none;
      @apply border border-solid border-secondary-100;
    }

    a {
      @apply no-underline;
    }

    .basic {
      @apply text-secondary-400;
      &[class*='outline'] {
        @apply hover:border-secondary-200;
        @apply active:border-secondary-300;
      }
      &.solid {
        @apply bg-secondary-100;
        @apply hover:bg-secondary-200;
        @apply active:bg-secondary-300;
      }
      &.solid-outline {
        @apply bg-neutral-lightest;
        @apply hover:bg-brand-50;
        @apply active:bg-brand-100;
      }
    }

    .brand {
      &[class*='outline'] {
        @apply border-solid border border-brand-500;
        @apply hover:border-brand-600;
        @apply active:border-brand-700;
      }
      &.solid-outline,
      &.transparent {
        @apply hover:bg-brand-50;
        @apply active:bg-brand-100;
      }
      &.solid {
        @apply bg-brand-500;
        @apply text-neutral-lightest;
        @apply hover:bg-brand-600;
        @apply active:bg-brand-700;
      }
      &.solid-outline {
        @apply bg-neutral-lightest;
      }
    }

    .inverse {
      @apply text-neutral-lightest;
      &.inline {
        @apply hover:text-opacity-75;
        @apply active:text-opacity-50;
        @apply hover:text-neutral-lightest;

        /* TODO: delete the below rule sets when tailwind opacity is fixed */
        &:hover {
          color: rgba(var(--colors-neutral-lightest-rgb), 0.75);
        }

        &:active {
          color: rgba(var(--colors-neutral-lightest-rgb), 0.5);
        }
      }
      &[class*='outline'] {
        @apply border-solid border border-neutral-lightest;
      }
      &.solid {
        @apply bg-neutral-lightest;
        @apply text-secondary-400;
        @apply hover:bg-brand-50;
        @apply hover:text-brand-600;
        @apply active:bg-brand-100;
        @apply active:text-brand-700;
      }
      &[class*='transparent'] {
        @apply hover:text-neutral-lightest;
        @apply hover:bg-opacity-10;
        @apply active:text-neutral-lightest;
        @apply active:bg-opacity-20;
        /* TODO: delete the below rule sets when tailwind opacity is fixed */
        &:hover {
          background-color: rgba(var(--colors-neutral-lightest-rgb), 0.1);
        }
        &:active {
          background-color: rgba(var(--colors-neutral-lightest-rgb), 0.2);
        }
      }
    }

    &([disabled]) {
      @apply pointer-events-none;

      a,
      button {
        @apply pointer-events-none;
        @apply text-secondary-100;
      }
      .solid {
        @apply bg-secondary-100;
      }
      .basic,
      .brand {
        &.solid-outline {
          @apply bg-neutral-lightest;
        }
      }
      .basic,
      .inverse {
        &.solid {
          @apply text-neutral-lightest;
        }
      }
      .brand {
        &[class*='outline'] {
          @apply border-secondary-100;
        }
      }

      .inverse {
        @apply text-opacity-20;
        /* TODO: delete the property below when tailwind opacity is fixed */
        color: rgba(var(--colors-neutral-lightest-rgb), 0.2);
        &.solid {
          @apply bg-secondary-100;
        }
        &.transparent-outline {
          @apply border-opacity-20;
          /* TODO: delete the property below when tailwind opacity is fixed */
          border-color: rgba(var(--colors-neutral-lightest-rgb), 0.2);
        }
      }
    }
  }
}
